export type EmojiPickerPlacement = 'top' | 'bottom'
export type EmojiPickerAlign = 'left' | 'right'

export type ComputeEmojiPickerPlacementParams = {
  buttonRect: DOMRect
  containerRect?: DOMRect | null
  estimatedPickerHeight: number
  pickerWidth: number
  gap?: number
}

export function computeEmojiPickerPlacement({
  buttonRect,
  containerRect,
  estimatedPickerHeight,
  pickerWidth,
  gap = 12,
}: ComputeEmojiPickerPlacementParams): { placement: EmojiPickerPlacement; align: EmojiPickerAlign } {
  const rect = containerRect

  const viewportHeight =
    typeof window !== 'undefined'
      ? window.innerHeight || document.documentElement.clientHeight || 0
      : 0
  const viewportWidth =
    typeof window !== 'undefined'
      ? window.innerWidth || document.documentElement.clientWidth || 0
      : 0

  const spaceBelow = rect ? rect.bottom - buttonRect.bottom : viewportHeight - buttonRect.bottom
  const spaceAbove = rect ? buttonRect.top - rect.top : buttonRect.top

  let placement: EmojiPickerPlacement = 'bottom'
  if (spaceBelow < estimatedPickerHeight + gap && spaceAbove > spaceBelow) {
    placement = 'top'
  }

  const spaceRight = rect ? rect.right - buttonRect.left : viewportWidth - buttonRect.left
  const spaceLeft = rect ? buttonRect.right - rect.left : buttonRect.right

  const enoughRight = spaceRight >= pickerWidth + gap
  const enoughLeft = spaceLeft >= pickerWidth + gap

  let align: EmojiPickerAlign = 'left'
  if (enoughRight && !enoughLeft) align = 'left'
  else if (!enoughRight && enoughLeft) align = 'right'
  else if (enoughRight && enoughLeft) align = spaceRight >= spaceLeft ? 'left' : 'right'
  else align = spaceRight >= spaceLeft ? 'left' : 'right'

  return { placement, align }
}

